import React from 'react';

import { ScreenProps } from '../ScreenBase';
import NextButton from '../NextButton';

class Note extends React.Component<ScreenProps> {

  render() {
    const { data: { order, extended_props }, locked, onSubmit } = this.props;
    const { button_text } = extended_props || {};
    const buttonText = order === 1 ? button_text??'Comenzar' : undefined;
    return <NextButton visible={!locked} onClick={()=>onSubmit({})} text={buttonText} />;
  }
}

export default Note;
